import { z } from 'zod';

import { apiClient } from './api-client';

const checklistItemSchema = z.object({
  id: z.string(),
  category: z.enum(['integrations', 'data']),
  label: z.string(),
  description: z.string(),
  done: z.boolean(),
  href: z.string(),
  manualHint: z.string().optional(),
});

const checklistResponseSchema = z.object({
  data: z.object({
    items: z.array(checklistItemSchema),
    total: z.number(),
    done: z.number(),
    percent: z.number(),
  }),
});

export type ChecklistItem = z.infer<typeof checklistItemSchema>;
export type ChecklistData = z.infer<typeof checklistResponseSchema>['data'];

export async function fetchSetupChecklist(): Promise<ChecklistData> {
  const { data } = await apiClient.get('/api/setup/checklist');
  return checklistResponseSchema.parse(data).data;
}
